import { mount } from '../../../js/dom-lifecycle';
import * as basicLightbox from 'basiclightbox';
import { rotateImage } from '../rotate-image';

mount('[data-verify-receipt-image]', function (el, refs) {
    const { img, rotateLeft, rotateRight } = refs;
    rotateLeft.addEventListener('click', () => rotateImage(img, -90));
    rotateRight.addEventListener('click', () => rotateImage(img, +90));
    img.addEventListener('click', () => {
        const instance = basicLightbox.create(
            `<div class="receipt-lightbox-image"><img class="receipt-lightbox-img" src="${img.src}"></div>`
        );
        instance.show();
        instance.element().querySelector('.receipt-lightbox-img')
            .addEventListener('click', () => instance.close());
    });
});

mount('[data-verify-receipt]', function () {
    const $container = $(this);
    const $collection = $container.find('[data-ref=collection]');
    const $addButton = $container.find('[data-ref=add-product]');

    $addButton.on('click', function () {
        const prototype = $collection.data('prototype');
        const index = $collection.data('index');
        const newRow = prototype.replace(/__name__/g, index);
        $collection.data('index', index + 1);
        $collection.append(newRow);
    });
});

mount('[data-verify-receipt-product]', function () {
    const $removeButton = $(this).find('[data-ref=remove-product]');

    $removeButton.on('click', () => $(this).remove());
});